<template>
  <div class="retention">
    <div class="row">
      <div class="col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">Member Retention</h1>
          </div>
          <div class="box-body">
            <form class="form-horizontal" @submit.prevent="refreshChart()">
              <div class="form-group row">
                <div class="col-sm-8 offset-sm-4">
                  <h3>Generate Graphs</h3>
                </div>
              </div>
              <date-time-range-input  v-bind:field="searchCriteria.dateRange"></date-time-range-input>
              <object-select-input :field="searchCriteria.freq"></object-select-input>
              <div class="form-group row">
                <div class="col-sm-8 offset-sm-4">
                  <span class="pull-right">
                    <button type="submit" class="btn btn-default"><i class="fa fa-fw fa-sync"></i> Refresh</button>
                  </span>
                </div>
              </div>
            </form>
            <!-- <form class="form-horizontal" @submit.prevent="emailData()">
              <div class="form-group row">
                <div class="col-sm-8 offset-sm-4">
                  <h3>Email Excel Data</h3>
                </div>
              </div>
              <email-input :field="searchCriteria.email"></email-input>
              <div class="form-group row">
                <div class="col-sm-8 offset-sm-4">
                  <span class="pull-right">
                    <button type="submit" class="btn btn-default"><i class="fa fa-fw fa-envelope"></i> Email</button>
                  </span>
                </div>
              </div>
            </form> -->
            <div class="row">
              <div class="col-sm-8">
                <h4>Quit Members</h4>
                <canvas id="appChart" ref="appChart"></canvas>
              </div>
              <div class="col-sm-4">
                <div class="list-group-item">
                  <span class="total-heading">Total:</span> {{ total }}<br/>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h4>Reasons for quiting</h4>
                <canvas width="1000" height="400" id="wordcloud"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Reporting Confirmation -->
    <modal ref="confirmationModal" v-if="confirming">
      <template slot="header">
        <h4 class="modal-title" id="confirmationModalLabel">Success!</h4>
      </template>
      <template slot="body">
        <div class="alert alert-sucess">Your report was succesfully sent</div>
      </template>
    </modal>
  </div>
</template>

<script>
import EmailInput from '../inputs/EmailInput.vue'
import Modal from '../Modal'
import Chart from 'chart.js'
import ObjectSelectInput from '../inputs/ObjectSelectInput.vue'
import CheckboxInput from '../inputs/CheckboxInput.vue'
import WordCloud from 'wordcloud'

export default {
  name: 'Retention',
  components: {
    EmailInput,
    Modal,
    ObjectSelectInput,
    CheckboxInput
  },
  data () {
    return {
      confirming: false,
      cars: [],
      count: 0,
      searchCriteria: {
        email: {
          name: 'to',
          label: 'Email To',
          value: '',
          confirmation: true,
          valid: false,
          dirty: false
        },
        dateRange: {
          name: 'dateRange',
          label: 'Report Date Range',
          type: 'date-time-range',
          fromValue: moment().subtract(1, 'month').add(1, 'day').format('DD/MM/YYYY'),
          toValue: moment().format('DD/MM/YYYY')
        },
        freq: {
          label: 'Frequency',
          name: 'freq',
          objectName: 'name',
          value: 'day',
          dirty: false,
          valid: false,
          objects: [
            { uuid: 'day', name: 'Per Day' },
            { uuid: 'week', name: 'Per Week' },
            { uuid: 'month', name: 'Per Month' },
            { uuid: 'year', name: 'Per Year' }
          ]
        }
      },
      chart: {},
      total: 0,
      wordList: []
    }
  },
  mounted () {
    this.wordCloud()
    this.chart = new Chart(this.$refs.appChart, {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'Quit',
            data: [],
            backgroundColor: 'rgba(255, 99, 132, 0.55)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1
          }
        ]
      },
      options: {
        scales: {
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            stacked: true
          }]
        }
      }
    })
    this.refreshChart()
  },
  methods: {
    refreshChart () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/object/retentionChart`, { searchCriteria: this.searchCriteria }).then(({ data }, status, request) => {
        this.total = data.object.total
        this.chart.data.labels = data.object.labels
        this.chart.data.datasets[0].data = data.object.quitMembers
        this.chart.update(1000)
      })
    },
    emailData () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/object/emailApplicationData`, { searchCriteria: this.searchCriteria }).then(({ data }, status, request) => {
        this.confirming = true
        this.$nextTick(function () {
          $(this.$refs.confirmationModal).modal()
          $(this.$refs.confirmationModal).on('hidden.bs.modal', (e) => {
            this.confirming = false
          })
        })
      })
    },
    wordCloud () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/quitWordCloud`, {}).then(({ data }, status, request) => {
        this.wordList = data.object
        WordCloud(document.getElementById('wordcloud'), {
          list: this.wordList
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Retention.vue